import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { DOM } from "@siteimprove/alfa-aria";
import { Element, Namespace, Node, Query, Text } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import { String } from "@siteimprove/alfa-string";
import { Style } from "@siteimprove/alfa-style";
import { Criterion, Technique } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { Scope, Stability } from "../tags/index.js";
const { hasAccessibleName, hasRole, isPerceivableForAll } = DOM;
const { hasAttribute, hasNamespace } = Element;
const { hasDescendant } = Node;
const { and, test } = Predicate;
const { isFocusable } = Style;
const { getElementDescendants } = Query;
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r14",
    requirements: [Criterion.of("2.5.3"), Technique.of("G208")],
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return getElementDescendants(document, Node.fullTree).filter(and(hasNamespace(Namespace.HTML, Namespace.SVG), hasAttribute((attribute) => attribute.name === "aria-label" ||
                    attribute.name === "aria-labelledby"), isFocusable(device), hasRole(device, (role) => role.isWidget() && role.isNamedBy("contents")), hasDescendant(and(Text.isText, isPerceivableForAll(device)), Node.flatTree)));
            },
            expectations(target) {
                const removePunctuationAndNormalise = String.Transformer.and(String.removePunctuation, String.normalize);
                const textContent = removePunctuationAndNormalise(Style.innerText(device, isPerceivableForAll)(target));
                let name = "";
                const accessibleNameIncludesTextContent = test(hasAccessibleName(device, (accessibleName) => {
                    name = removePunctuationAndNormalise(accessibleName.value);
                    return name.includes(textContent);
                }), target);
                return {
                    1: expectation(accessibleNameIncludesTextContent, () => Outcomes.VisibleIsInName(textContent, name), () => Outcomes.VisibleIsNotInName(textContent, name)),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.VisibleIsInName = (textContent, name) => Ok.of(LabelAndName.of(`The visible text content of the element is included within its accessible name`, textContent, name));
    Outcomes.VisibleIsNotInName = (textContent, name) => Err.of(LabelAndName.of(`The visible text content of the element is not included within its accessible name`, textContent, name));
})(Outcomes || (Outcomes = {}));
/**
 * @public
 */
export class LabelAndName extends Diagnostic {
    static of(message, textContent = "", name = "") {
        return new LabelAndName(message, textContent, name);
    }
    _textContent;
    _name;
    constructor(message, textContent, name) {
        super(message);
        this._textContent = textContent;
        this._name = name;
    }
    get textContent() {
        return this._textContent;
    }
    get name() {
        return this._name;
    }
    equals(value) {
        return (value instanceof LabelAndName &&
            value._message === this._message &&
            value._textContent === this._textContent &&
            value._name === this._name);
    }
    hash(hash) {
        super.hash(hash);
        hash.writeString(this._name);
        hash.writeString(this._textContent);
    }
    toJSON(options) {
        return {
            ...super.toJSON(options),
            textContent: this._textContent,
            name: this._name,
        };
    }
}
/**
 * @public
 */
(function (LabelAndName) {
    /**@public */
    function isLabelAndName(value) {
        return value instanceof LabelAndName;
    }
    LabelAndName.isLabelAndName = isLabelAndName;
})(LabelAndName || (LabelAndName = {}));
//# sourceMappingURL=rule.js.map